function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import { classNamesFor } from '../utils/classNames';
import ServiceIcon from '../commerce/ServiceIcon';

var Badge = function Badge(_ref) {
  var qa = _ref.qa,
      className = _ref.className,
      type = _ref.type,
      text = _ref.text,
      disabled = _ref.disabled,
      ariaHidden = _ref.ariaHidden;
  if (!text) return null;

  var _Badge$getClassName = Badge.getClassName({
    className: className,
    type: type,
    disabled: disabled
  }),
      root = _Badge$getClassName.root,
      textClass = _Badge$getClassName.text,
      serviceIconClass = _Badge$getClassName.serviceIcon;

  return /*#__PURE__*/React.createElement("div", _extends({
    "data-qa": qa,
    className: root
  }, ariaHidden !== undefined ? {
    'aria-hidden': ariaHidden
  } : {}), /*#__PURE__*/React.createElement("span", {
    "data-qa": "".concat(qa, "#text"),
    className: textClass
  }, text, type && type !== 'NONE' && /*#__PURE__*/React.createElement(ServiceIcon, {
    qa: "".concat(qa, "#service-icon"),
    className: serviceIconClass,
    serviceType: type
  })));
};

var cx = classNamesFor(Badge);

Badge.getClassName = function (_ref2) {
  var className = _ref2.className,
      type = _ref2.type,
      disabled = _ref2.disabled;
  return {
    root: cx(className, 'psw-badge', 'psw-l-anchor', 'psw-l-inline', 'psw-r-1', disabled && 'psw-dimmed'),
    text: cx('psw-body-2', 'psw-badge__text', "psw-badge--".concat(type.replace(/_/g, '-').toLowerCase()), "".concat(type === 'INFO' ? 'psw-c-bg-info-1' : ''), "".concat(type === 'PROMO' ? 'psw-c-bg-promo-1' : ''), "".concat(type === 'PS_PLUS' ? 'psw-c-bg-ps-plus' : ''), 'psw-text-bold', 'psw-p-y-0', 'psw-p-2', 'psw-r-1', 'psw-l-anchor'),
    serviceIcon: cx('psw-l-anchor-top-right')
  };
};

Badge.defaultProps = {
  qa: '',
  className: '',
  type: 'NONE',
  disabled: false,
  ariaHidden: undefined
};
Badge.propTypes = {
  qa: PropTypes.string,
  className: PropTypes.string,
  type: PropTypes.string,
  text: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  ariaHidden: PropTypes.bool
};
export default Badge;